import { put, call } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
// Actions 
import {
  reportsMainGenerateReportProgress
} from 'Redux/actions'; 

import {
  getTimeZone
} from 'Modules/reports/views/main/components/reportsTab/helper';

function* getStopHistoryDetailsReport(report, event) {
  const { timeZone, name, reportTimeRanges } = report;
  const { startRange, endRange } = report.filters;
  const {
    filterType,
    filterArray,
    page,
    rowsPerPage,
    sortField,
    sortOrder,
    otherFilters
  } = event.filters;
  try {
      const newReport = JSON.parse(JSON.stringify(report))
      let data = yield call(
        clientQuery,
        `query getStopHistoryDetailsReport ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
          getStopHistoryDetailsReport (conditions: $conditions, limit: $limit, offset: $offset) {
              items {
                dateTime    
                address
                title
                status
                tripDuration
                latitude
                longitude
              }
              total
              limit
              offset
              category
          }
      }`,
        {
          "conditions": {
            reportName: name,
            "category": {
              field: filterType,
              value: filterArray?.id
            },
            timeZone: getTimeZone(timeZone),
            dateRange: {
              fields: [
                "unitTime"
              ],
              GTE: startRange,
              LTE: endRange,
              reportTimeRanges
            },
            sortField: {
              field: sortField || "deviceId",
              order: sortOrder === 'desc' ? 'DESC' : 'ASC'
            }
          },
          limit: rowsPerPage,
          offset: page
        },
        endpoints.GRAPHQL_PX_REPORTING
      );
      
      if (data?.getStopHistoryDetailsReport) {
        newReport.summary = data.getStopHistoryDetailsReport
        newReport.loadingSummary = false
        yield put(reportsMainGenerateReportProgress(newReport))
      } else {
        newReport.loadingSummary = false
        yield put(reportsMainGenerateReportProgress(newReport))
      }
    } catch (exc) {
      report.loadingSummary = false
      ExceptionManager(exc, 'src/modules/reports/views/main/components/reportsTab/.components/reports/stopReport', 'getStopHistoryDetailsReport');
      yield put(reportsMainGenerateReportProgress(report))
    }
  }


export default getStopHistoryDetailsReport;